import React, { useEffect, useState } from 'react'
import { Grid, Box, Paper, useMediaQuery } from '@material-ui/core'
import illustration2 from '../../assets/images/illustration2.svg'
import CardIterator from './components/CardIterator'
import { ExtAgsTable } from './components/ExtAgsTable/ExtAgsTable'
import useFetchData from './hooks/useFetchData'
import PreviewFile from './components/PreviewFile'

export const ExtAG = ({ coproprietaire_id, copro_id }) => {
  if (!coproprietaire_id || !copro_id) {
    return null
  }
  const [file, setFile] = useState('')
  const [open, setOpen] = useState(false)
  const [openDetail, setOpenDetail] = useState(false)
  const { data, isLoading } = useFetchData(copro_id, coproprietaire_id)

  useEffect(() => {
    if (file) {
      setOpen(true)
    }
  }, [file])

  useEffect(() => {
    if (!open) {
      setFile('')
    }
  }, [open])

  return (
    <Box component={Paper} padding={'20px'}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={12} lg={8}>
          {useMediaQuery('(max-width:768px)') ? (
            <Box>
              <CardIterator
                data={data}
                isLoading={isLoading}
                setOpenDetail={setOpenDetail}
                openDetail={openDetail}
                coproprietaire_id={coproprietaire_id}
                copro_id={copro_id}
                setFile={setFile}
              />
            </Box>
          ) : (
            <ExtAgsTable
              data={data}
              setOpenDetail={setOpenDetail}
              openDetail={openDetail}
              coproprietaire_id={coproprietaire_id}
              copro_id={copro_id}
              setFile={setFile}
            />
          )}
        </Grid>
        <Grid item xs={12} md={12} lg={4}>
          <Box
            component={'img'}
            src={illustration2}
            width={'100%'}
            maxHeight={'300px'}
          />
        </Grid>
      </Grid>
      <PreviewFile
        path={file}
        open={open}
        onClose={() => {
          setOpen(false)
        }}
      />
    </Box>
  )
}
export default ExtAG
